
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 534 497","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M266.567 0c29.154.813 54.351 19.038 73 17.972 35-2 31.048-11.394 49-9 15 2 25.837 18.558 37 26 24 16 95 68 106 163 10.932 94.402-38.371 137.291-53 152-14.628 14.709-46.379 38.739-61 50-14.62 11.261-42.392 34.233-57 60-14.607 25.767-22.276 37.423-31 36-8.723-1.423-4.86-95.832 30-131 34.86-35.168 74.637-43.173 77-91 2.364-47.827-20.2-64.962-32-65-11.8-.038-31.088 3.386-39 20 0 0-.415 24.997-6 38-5.584 13.003-10.897 23.053-33 30-34.279 10.773-13.882 53.201-60 54.945-46.118-1.744-25.72-44.172-60-54.945-22.103-6.947-27.415-16.997-33-30-5.584-13.003-6-38-6-38-7.911-16.614-27.2-20.038-39-20-11.8.038-34.363 17.173-32 65 2.364 47.827 42.14 55.832 77 91s38.724 129.577 30 131c-8.723 1.423-16.392-10.233-31-36-14.607-25.767-42.379-48.739-57-60-14.62-11.261-46.372-35.291-61-50-14.627-14.709-63.93-57.598-53-152 11-95 82-147 106-163 11.164-7.442 22-24 37-26 17.952-2.394 14 7 49 9 18.65 1.066 43.847-17.159 73-17.972zm0 309.909c-3.401-.046-8.766-.67-11-3.937 0 0-1.653-.484 3-9 4.654-8.516 4.488-12 8-12 3.513 0 3.347 3.484 8 12 4.654 8.516 3 9 3 9-2.233 3.267-7.598 3.891-11 3.937zm69-61.937c-1.714-3.012-6.704-7.995-19-5-12.295 2.995-20.055 14.732-21 27 0 0 14 10 30-2 12.65-9.487 10-20 10-20zm-138 0c1.714-3.012 6.705-7.995 19-5 12.296 2.995 20.055 14.732 21 27 0 0-14 10-30-2-12.649-9.487-10-20-10-20z"}})])
          )
        }
      }
    